import gql from 'graphql-tag';

/* export class EdocSeriesInput {
  id: number;
  docPrefix: string;
  startNumber: number;
  endNumber: number;
} */

export class FormInput {
  id: number;
  legacyAppId: string;
  name: string;
  companyVat: string;
  companyTaxOffice: string;
  imaCode: string;
  imaCode2: string;
  contractNo: string;
  contractSignDate: Date;
  contractExpDate: Date;
  formalName: string;
  addressLine1: string;
  addressLine2: string;
  addressArea: string;
  addressCity: string;
  addressNomos: string;
  postalCode: string;
  regionId: number;
  subregionId: number;
  phone: string;
  mobile: string;
  fax: string;
  email: string;
  email2: string;
  website: string;
  contactperson: string;
  notes: string;
  hasGps: boolean;
  insurancePolicyNumber: string;
  insuranceExpirationDate: Date;
  hazardousWastePermit: string;
  hazardousWasteExpDate: Date;
  environmentalPermit: string;
  envPermitExpirationDate: Date;
  adrConsultantAgrExpDate: Date;
  sameePermitExpDate: Date;
  recordDate: Date;
  signatureFileId: number;
  stampFileId: number;
  insuranceFileId: number;
  hazardousWastePermitFileId: number;
  adrFileId: number;
  proofColPermitRenewalFileId: number;
  sameePermitFileId: number;
  isActive: boolean;
  firstDate: Date;
  lastDate: Date;
  firstUser: string;
  lastUser: string;
  isApproved: boolean;
  approvedBy: string;
  approvedDate: Date;
  //edocSeries: [EdocSeriesInput];

  constructor() {
    this.id = undefined;
    this.legacyAppId = undefined;
    this.name = undefined;
    this.companyVat = undefined;
    this.companyTaxOffice = undefined;
    this.imaCode = undefined;
    this.imaCode2 = undefined;
    this.contractNo = undefined;
    this.contractSignDate = undefined;
    this.contractExpDate = undefined;
    this.formalName = undefined;
    this.addressLine1 = undefined;
    this.addressLine2 = undefined;
    this.addressArea = undefined;
    this.addressCity = undefined;
    this.addressNomos = undefined;
    this.postalCode = undefined;
    this.regionId = undefined;
    this.subregionId = undefined;
    this.phone = undefined;
    this.mobile = undefined;
    this.fax = undefined;
    this.email = undefined;
    this.email2 = undefined;
    this.website = undefined;
    this.contactperson = undefined;
    this.notes = undefined;
    this.hasGps = undefined;
    this.insurancePolicyNumber = undefined;
    this.insuranceExpirationDate = undefined;
    this.hazardousWastePermit = undefined;
    this.hazardousWasteExpDate = undefined;
    this.environmentalPermit = undefined;
    this.envPermitExpirationDate = undefined;
    this.adrConsultantAgrExpDate = undefined;
    this.sameePermitExpDate = undefined;
    this.recordDate = undefined;
    this.signatureFileId = undefined;
    this.stampFileId = undefined;
    this.insuranceFileId = undefined;
    this.hazardousWastePermitFileId = undefined;
    this.adrFileId = undefined;
    this.proofColPermitRenewalFileId = undefined;
    this.sameePermitFileId = undefined;
    this.isActive = undefined;
    this.firstDate = undefined;
    this.lastDate = undefined;
    this.firstUser = undefined;
    this.lastUser = undefined;
    this.isApproved = undefined;
    this.approvedBy = undefined;
    this.approvedDate = undefined;
  }
}

export const gqlGetQuery = gql`
  query getCollectors($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectors(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        legacyAppId
        name
        companyVat
        companyTaxOffice
        imaCode
        imaCode2
        contractNo
        contractSignDate
        contractExpDate
        formalName
        addressLine1
        addressLine2
        addressArea
        addressCity
        addressNomos
        postalCode
        regionId
        subregionId
        phone
        mobile
        fax
        email
        email2
        website
        contactperson
        notes
        insurancePolicyNumber
        insuranceExpirationDate
        hazardousWastePermit
        hazardousWasteExpDate
        environmentalPermit
        envPermitExpirationDate
        adrConsultantAgrExpDate
        recordDate
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getCollectorById($id: Int) {
    getCollectorById(id: $id) {
      id
      legacyAppId
      name
      companyVat
      companyTaxOffice
      imaCode
      imaCode2
      contractNo
      contractSignDate
      contractExpDate
      formalName
      addressLine1
      addressLine2
      addressArea
      addressCity
      addressNomos
      postalCode
      regionId
      subregionId
      phone
      mobile
      fax
      email
      email2
      website
      contactperson
      notes
      isApproved
      approvedBy
      approvedDate
      hasGps
      insurancePolicyNumber
      insuranceExpirationDate
      hazardousWastePermit
      hazardousWasteExpDate
      environmentalPermit
      envPermitExpirationDate
      adrConsultantAgrExpDate
      sameePermitExpDate
      recordDate
      insuranceFileId
      hazardousWastePermitFileId
      adrFileId
      proofColPermitRenewalFileId
      sameePermitFileId
      signatureFileId
      stampFileId
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      drivers {
        id
        name
        notes
        phone
        collectorId
        collector {
          id
          name
        }
        licenseExpDate
        licenseFileId
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      # collectorMaterials {
      #   id
      #   collectorId
      #   materialId
      #   material {
      #     id
      #     name
      #   }
      # }
    }
  }
`;

export const gqlAdd = gql`
  mutation addCollector($data: CollectorInput) {
    addCollector(data: $data) {
      id
      name
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCollector($data: CollectorInput) {
    updateCollector(data: $data) {
      id
      name
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCollector($id: Int) {
    deleteCollector(id: $id)
  }
`;

export const gqlAccept = gql`
  mutation acceptCollector($id: Int) {
    acceptCollector(id: $id)
  }
`;
